if (!customElements.get("m-stats-showcase")) {
  class MStatsShowcase extends HTMLElement {
    constructor() {
      super();
      this._played = false;
      this._io = null;
      this._onSectionLoad = (e) => {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        this._played = false;
        this._disconnectObserver();
        this._resetNumbersToStart();
        this._setup();
      };
    }

    connectedCallback() {
      document.addEventListener("shopify:section:load", this._onSectionLoad);
      this._setup();
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:section:load", this._onSectionLoad);
      this._disconnectObserver();
    }

    _disconnectObserver() {
      if (this._io) {
        this._io.disconnect();
        this._io = null;
      }
    }

    _resetNumbersToStart() {
      this.querySelectorAll("[data-stat-num][data-animate='true']").forEach((el) => {
        const start = el.getAttribute("data-start-display");
        if (start != null) el.textContent = start;
      });
    }

    _setup() {
      this._disconnectObserver();

      if (this.dataset.animate !== "true") {
        this._revealStatic();
        return;
      }

      this._io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.15) {
              this._runIfNeeded();
            }
          });
        },
        { threshold: [0, 0.15, 0.3] }
      );
      this._io.observe(this);

      requestAnimationFrame(() => {
        const r = this.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          this._runIfNeeded();
        }
      });
    }

    _revealStatic() {
      this.querySelectorAll("[data-stat-num]").forEach((el) => {
        const end = el.getAttribute("data-end-display");
        if (end != null) el.textContent = end;
      });
    }

    _runIfNeeded() {
      if (this._played) return;
      if (this.dataset.animate !== "true") return;
      this._played = true;
      this._disconnectObserver();

      const nums = this.querySelectorAll("[data-stat-num]");
      const duration = Math.min(2800, Math.max(500, parseInt(this.dataset.duration, 10) || 1400));

      nums.forEach((el, index) => {
        if (el.getAttribute("data-animate") !== "true") {
          const end = el.getAttribute("data-end-display");
          if (end != null) el.textContent = end;
          return;
        }

        const target = parseFloat(el.getAttribute("data-target"));
        const decimals = parseInt(el.getAttribute("data-decimals"), 10) || 0;
        if (Number.isNaN(target)) {
          const end = el.getAttribute("data-end-display") || "0";
          el.textContent = end;
          return;
        }

        const stagger = index * 85;
        setTimeout(() => this._animateNumber(el, target, decimals, duration), stagger);
      });
    }

    _animateNumber(el, target, decimals, duration) {
      const start = performance.now();

      const tick = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        const current = target * eased;
        let out;
        if (decimals > 0) {
          out = current.toFixed(decimals);
          if (t >= 1) out = target.toFixed(decimals);
        } else {
          out = String(Math.round(current));
          if (t >= 1) out = String(Math.round(target));
        }
        el.textContent = out;
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  }

  customElements.define("m-stats-showcase", MStatsShowcase);
}
